import { useTranslation } from 'react-i18next'

export default ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const label = t('Flag of United States.', { context: 'alt text for image of the US flag' })

  return (
    <svg
      width="32"
      height="18"
      viewBox="0 0 32 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={label}
      className={className}
    >
      <g clipPath="url(#clip0_93_17659)">
        <path d="M32 0H0V18H32V0Z" fill="#B22234" />
        <path
          d="M0 2.07666H32H0ZM32 4.84666H0H32ZM0 7.615H32H0ZM32 10.385H0H32ZM0 13.1533H32H0ZM32 15.9233H0H32Z"
          fill="black"
        />
        <path
          d="M32 16.615H0V15.23H32V16.615ZM32 13.8467H0V12.4617H32V13.8467ZM32 11.0767H0V9.69168H32V11.0767ZM32 8.30834H0V6.92334H32V8.30834ZM32 5.53834H0V4.15334H32V5.53834ZM32 2.77001H0V1.38501H32V2.77001Z"
          fill="white"
        />
        <path d="M13.68 0H0V9.69167H13.68V0Z" fill="#3C3B6E" />
        <path
          d="M1.14194 0.414917L1.46861 1.41658L0.611938 0.798251H1.66361L0.813605 1.41825L1.14194 0.414917Z"
          fill="white"
        />
        <path
          d="M1.14149 2.35339L1.46816 3.35506L0.613159 2.73506H1.66483L0.811493 3.35506L1.14149 2.35339Z"
          fill="white"
        />
        <path
          d="M1.14184 4.29163L1.46851 5.29329L0.615173 4.67329H1.66684L0.813507 5.29329L1.14184 4.29163Z"
          fill="white"
        />
        <path
          d="M1.14184 6.22998L1.46851 7.23332L0.615173 6.61331H1.66684L0.813507 7.23332L1.14184 6.22998Z"
          fill="white"
        />
        <path
          d="M1.14184 8.16992L1.46851 9.17159L0.615173 8.55159H1.66684L0.813507 9.17159L1.14184 8.16992Z"
          fill="white"
        />
        <path d="M2.2783 1.38501L2.60496 2.38668L1.7533 1.76668H2.80496L1.95496 2.38668L2.2783 1.38501Z" fill="white" />
        <path
          d="M2.27874 3.32336L2.60541 4.32503L1.75208 3.70503H2.80374L1.95041 4.32503L2.27874 3.32336Z"
          fill="white"
        />
        <path
          d="M2.27874 5.26172L2.60541 6.26339L1.75208 5.64339H2.80374L1.95041 6.26339L2.27874 5.26172Z"
          fill="white"
        />
        <path
          d="M2.27874 7.19995L2.60541 8.20162L1.75208 7.58162H2.80374L1.95041 8.20162L2.27874 7.19995Z"
          fill="white"
        />
        <path
          d="M3.42016 0.414917L3.74683 1.41658L2.89349 0.796584H3.94516L3.09183 1.41658L3.42016 0.414917Z"
          fill="white"
        />
        <path
          d="M3.42016 2.35339L3.74683 3.35506L2.89349 2.73506H3.94516L3.09183 3.35506L3.42016 2.35339Z"
          fill="white"
        />
        <path
          d="M3.42016 4.29163L3.74683 5.29329L2.89349 4.67329H3.94516L3.09183 5.29329L3.42016 4.29163Z"
          fill="white"
        />
        <path
          d="M3.42016 6.22998L3.74683 7.23165L2.89349 6.61165H3.94516L3.09349 7.23332L3.42016 6.22998Z"
          fill="white"
        />
        <path
          d="M3.42016 8.16992L3.74683 9.17159L2.89349 8.55159H3.94516L3.09183 9.17159L3.42016 8.16992Z"
          fill="white"
        />
        <path
          d="M4.56152 1.38501L4.88819 2.38668L4.03485 1.76668H5.08652L4.23318 2.38668L4.56152 1.38501Z"
          fill="white"
        />
        <path
          d="M4.56152 3.32336L4.88819 4.32503L4.03485 3.70503H5.08652L4.23318 4.32503L4.56152 3.32336Z"
          fill="white"
        />
        <path
          d="M4.56152 5.26172L4.88819 6.26339L4.03485 5.64339H5.08652L4.23318 6.26339L4.56152 5.26172Z"
          fill="white"
        />
        <path
          d="M4.56152 7.19995L4.88819 8.20162L4.03485 7.58162H5.08652L4.23318 8.20162L4.56152 7.19995Z"
          fill="white"
        />
        <path
          d="M5.69848 0.414917L6.02515 1.41658L5.17181 0.796584H6.22348L5.37015 1.41658L5.69848 0.414917Z"
          fill="white"
        />
        <path
          d="M5.69848 2.35339L6.02515 3.35506L5.17181 2.73506H6.22348L5.37015 3.35506L5.69848 2.35339Z"
          fill="white"
        />
        <path
          d="M5.69848 4.29163L6.02515 5.29329L5.17181 4.67329H6.22348L5.37015 5.29329L5.69848 4.29163Z"
          fill="white"
        />
        <path
          d="M5.69848 6.22998L6.02515 7.23165L5.17181 6.61165H6.22348L5.37181 7.23332L5.69848 6.22998Z"
          fill="white"
        />
        <path
          d="M5.69848 8.16992L6.02515 9.17159L5.17181 8.55159H6.22348L5.37015 9.17159L5.69848 8.16992Z"
          fill="white"
        />
        <path
          d="M6.83984 1.38501L7.16651 2.38668L6.31317 1.76668H7.36651L6.51317 2.38668L6.83984 1.38501Z"
          fill="white"
        />
        <path
          d="M6.83984 3.32336L7.16651 4.32503L6.31317 3.70503H7.36651L6.51317 4.32503L6.83984 3.32336Z"
          fill="white"
        />
        <path
          d="M6.83984 5.26172L7.16651 6.26339L6.31317 5.64339H7.36651L6.51317 6.26339L6.83984 5.26172Z"
          fill="white"
        />
        <path
          d="M6.83984 7.19995L7.16651 8.20162L6.31317 7.58162H7.36651L6.51317 8.20162L6.83984 7.19995Z"
          fill="white"
        />
        <path
          d="M7.9812 0.414917L8.30786 1.41658L7.45453 0.796584H8.5062L7.65286 1.41658L7.9812 0.414917Z"
          fill="white"
        />
        <path d="M7.9812 2.35339L8.30786 3.35506L7.45453 2.73506H8.5062L7.65286 3.35506L7.9812 2.35339Z" fill="white" />
        <path d="M7.9812 4.29163L8.30786 5.29329L7.45453 4.67329H8.5062L7.65286 5.29329L7.9812 4.29163Z" fill="white" />
        <path d="M7.9812 6.22998L8.30786 7.23165L7.45453 6.61165H8.5062L7.65286 7.23332L7.9812 6.22998Z" fill="white" />
        <path d="M7.9812 8.16992L8.30786 9.17159L7.45453 8.55159H8.5062L7.65286 9.17159L7.9812 8.16992Z" fill="white" />
        <path
          d="M9.11844 1.38501L9.44511 2.38668L8.59344 1.76668H9.64511L8.79178 2.38668L9.11844 1.38501Z"
          fill="white"
        />
        <path
          d="M9.11816 3.32336L9.44482 4.32503L8.59149 3.70503H9.64316L8.78983 4.32503L9.11816 3.32336Z"
          fill="white"
        />
        <path
          d="M9.11816 5.26172L9.44482 6.26339L8.59149 5.64339H9.64316L8.78983 6.26339L9.11816 5.26172Z"
          fill="white"
        />
        <path
          d="M9.11816 7.19995L9.44482 8.20162L8.59149 7.58162H9.64316L8.78983 8.20162L9.11816 7.19995Z"
          fill="white"
        />
        <path
          d="M10.2603 0.414917L10.587 1.41658L9.73364 0.798251H10.7853L9.93364 1.41825L10.2603 0.414917Z"
          fill="white"
        />
        <path
          d="M10.2603 2.35339L10.587 3.35506L9.73364 2.73673H10.7853L9.93364 3.35673L10.2603 2.35339Z"
          fill="white"
        />
        <path
          d="M10.2603 4.29163L10.587 5.29329L9.73364 4.67496H10.7853L9.93364 5.29496L10.2603 4.29163Z"
          fill="white"
        />
        <path
          d="M10.2603 6.22998L10.587 7.23165L9.73364 6.61331H10.7853L9.93364 7.23332L10.2603 6.22998Z"
          fill="white"
        />
        <path
          d="M10.2603 8.16992L10.587 9.17159L9.73364 8.55159H10.7853L9.93364 9.17159L10.2603 8.16992Z"
          fill="white"
        />
        <path
          d="M11.4017 1.38501L11.7283 2.38668L10.875 1.76668H11.9267L11.0733 2.38668L11.4017 1.38501Z"
          fill="white"
        />
        <path
          d="M11.4017 3.32336L11.7283 4.32503L10.875 3.70503H11.9267L11.0733 4.32503L11.4017 3.32336Z"
          fill="white"
        />
        <path
          d="M11.4017 5.26172L11.7283 6.26339L10.875 5.64339H11.9267L11.0733 6.26339L11.4017 5.26172Z"
          fill="white"
        />
        <path
          d="M11.4017 7.19995L11.7283 8.20162L10.875 7.58162H11.9267L11.0733 8.20162L11.4017 7.19995Z"
          fill="white"
        />
        <path
          d="M12.5382 0.414917L12.8665 1.41825L12.0132 0.798251H13.0649L12.2115 1.41825L12.5382 0.414917Z"
          fill="white"
        />
        <path
          d="M12.5386 2.35339L12.8653 3.35506L12.012 2.73506H13.0636L12.2103 3.35506L12.5386 2.35339Z"
          fill="white"
        />
        <path
          d="M12.5386 4.29163L12.8653 5.29329L12.012 4.67329H13.0636L12.2103 5.29329L12.5386 4.29163Z"
          fill="white"
        />
        <path
          d="M12.5382 6.22998L12.8665 7.23332L12.0132 6.61331H13.0649L12.2115 7.23332L12.5382 6.22998Z"
          fill="white"
        />
        <path
          d="M12.5386 8.16992L12.8653 9.17159L12.012 8.55159H13.0636L12.2103 9.17159L12.5386 8.16992Z"
          fill="white"
        />
      </g>
      <rect x="0.5" y="0.5" width="31" height="17" stroke="black" strokeOpacity="0.05" />
      <defs>
        <clipPath id="clip0_93_17659">
          <rect width="32" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
